module.exports = __webpack_public_path__ + "img/why.bb324fe4.png";